// @flow

import React, { Component } from 'react';
import styler from 'react-styling';

import { FullCalendar } from './index';
import { convertEvent } from '../libs/Extract';

const style = styler `
    Container
      position: relative
  `;

/* Takes the events from the Relay derived props and puts them into the
* format needed by fullCalendar widget. */
const mangleEvents = (contact: Object, me: Object) => {
  let eventsFromRelay = [];
  if (contact && contact.edges) {
    eventsFromRelay = contact.edges;
  } else {
    return [];
  }
  const events = eventsFromRelay.map(e => (convertEvent(e, me)));
  return events;
};


class Calendar extends Component {

  props: {
    languagedata: Object,
    startDate: Date,
    endDate: Date,
    initialView: string,
    events: Object,
    updateEvents: Function,
    showCalendar: number,
    me: Object,
  }
  render() {
    const uniqueId = Math.random();
    const events = mangleEvents(this.props.events, this.props.me);
    return (
      <div style={style.contaier}>
        { this.props.showCalendar === 1 ?
          <FullCalendar
            key={uniqueId}
            languagedata={this.props.languagedata}
            events={events}
            updateEvents={this.props.updateEvents}
            initialView={this.props.initialView}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
          />
        : null}
      </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/js/Components/Calendar.js